// src/components/ConflictIndicator.jsx
import React from 'react';
import HelpIcon from './Documentation/HelpIcon';

// Warning Icon SVG - updated to match other floating buttons
const WarningIcon = ({ hasConflicts }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
);

function ConflictIndicator({ conflictCount = 0, onClick }) {
    const hasConflicts = conflictCount > 0;

    const conflictStyle = hasConflicts
        ? 'bg-gray-200 hover:bg-gray-300 text-red-600'
        : 'bg-green-600 hover:bg-green-700 text-white';

    return (
        <div className="relative">
            <button
                onClick={onClick}
                className={`relative rounded-full w-10 h-10 flex items-center justify-center shadow-sm transition-all duration-200 ease-in-out cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${conflictStyle}`}
            >
                <WarningIcon hasConflicts={hasConflicts} />

                {hasConflicts && (
                    <span
                        className="absolute -top-0.5 -right-0.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full px-0.5 text-[9px] font-bold leading-none text-white bg-red-600"
                    >
                        {conflictCount}
                    </span>
                )}
            </button>
            <HelpIcon
                documentationId="conflict-indicator"
                variant="help"
                appearance="badge"
                badgeCorner="top-left"
            />
        </div>
    );
}

export default ConflictIndicator;